import { parseJSON } from '@prophecy/utils/string';

import { RECENT_FABRIC, SESSION_FABRIC_MAP } from '../utils/localstorage-keys';

export const getSessionFabricMap = () => {
  let json = localStorage.getItem(SESSION_FABRIC_MAP) || '';
  const obj = parseJSON(json, {});
  return obj as unknown as { [key: string]: string };
};

export const PROJECT_PREFIX = '_project';
export const SERVERLESS_PREFIX = '_serverless';

export const setSessionFabricMap = (id: string, fabricId: string, projectId = '', isServerless: boolean) => {
  const sessionMap = getSessionFabricMap();
  localStorage.setItem(RECENT_FABRIC, fabricId);
  sessionMap[fabricId] = id + (isServerless ? SERVERLESS_PREFIX : '') + PROJECT_PREFIX + projectId;
  localStorage.setItem(SESSION_FABRIC_MAP, JSON.stringify(sessionMap));
};

export const deleteRecentFabric = (fabricId: string) => {
  const sessionMap = getSessionFabricMap();
  localStorage.removeItem(RECENT_FABRIC);
  delete sessionMap[fabricId];
  localStorage.setItem(SESSION_FABRIC_MAP, JSON.stringify(sessionMap));
};

export const getCurrentSessionAndFabric = () => {
  const recentFabric = localStorage.getItem(RECENT_FABRIC) || undefined;
  const sessionMap = getSessionFabricMap();
  const recentSessionWithProject = recentFabric ? sessionMap?.[recentFabric] : '';
  const [prefix, recentProjectId] = (recentSessionWithProject || '').split(PROJECT_PREFIX);
  const [recentSession] = prefix.split(SERVERLESS_PREFIX);
  return [recentSession, recentFabric, recentProjectId, prefix.endsWith(SERVERLESS_PREFIX)] as const;
};
